/* import __COLOCATED_TEMPLATE__ from './segment.hbs'; */
/**

## Segment

The Segment component is a singular component to be used within the [navigation](../../navigation.html)
of a [Selector Control component](../../../selector-control.html)

```example
@title Inactive

@hbs
{{selector-control/navigation/item/segment label="Inactive Segment"}}
```

```example
@title Active

@hbs
{{selector-control/navigation/item/segment label="Active Segment" isActive=true}}
```

```example
@title Passing a block
@description You can pass a block to use as the text of the segment instead of passing a string through the label param

@hbs
{{#selector-control/navigation/item/segment isActive=true}}
  Segment with <em>Emphasis</em>
{{/selector-control/navigation/item/segment}}
```

@param {String} label - Text for the segment. Can also pass a block instead
@param {Boolean} isActive=false - Determines whether or not the segment is in an active state
*/

import Component from '@ember/component';
import { computed } from '@ember/object';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'button',
  classNames: ['button', 'segmented-control__segment'],
  classNameBindings: ['isActive:segmented-control__segment--selected'],
  attributeBindings: ['data-test-selector-control-segment'],
  'data-test-selector-control-segment': computed('isActive', function () {
    if (this.get('isActive')) {
      return 'active';
    } else {
      return 'inactive';
    }
  }),
  isActive: false,
  click() {
    if (this.onSelect) {
      this.onSelect(this);
    }
  }
});